<template>
  <div class="pt-12">
    <main class="overflow-hidden"> 
      <FeaturesHeroSection />
      <FeaturesCustomizableSection />
      <FeaturesPaymentSection />
      <FeaturesComprehensiveSection />
    </main>
  </div>
</template>

<script setup>
import FeaturesHeroSection from '~/components/features/FeaturesHeroSection.vue'
import FeaturesCustomizableSection from '~/components/features/FeaturesCustomizableSection.vue'
import FeaturesPaymentSection from '~/components/features/FeaturesPaymentSection.vue'
import FeaturesComprehensiveSection from '~/components/features/FeaturesComprehensiveSection.vue'
import { useSeo } from '~/composables/useSeo'
import { useI18n } from '#imports'

const { t } = useI18n()

definePageMeta({
  layout: 'default'
})

useSeo({
  title: t('pages.features.meta.title') || 'Features - ommi.shop',
  description: t('pages.features.meta.description') || 'Discover ommi.shop features: customizable product pages, flexible pricing, global payments, and tools to showcase your imperfect art and unique creations.',
  keywords: 'ommi.shop features, marketplace features, seller tools, customizable pages, flexible pricing, global payments',
  type: 'website'
})
</script> 